export const boxProgrammationKeys = {
  all: ["boxProgrammation"] as const,
  programmations: (filters?: { page?: number; pageSize?: number }) =>
    filters
      ? ([...boxProgrammationKeys.all, "programmations", filters] as const)
      : ([...boxProgrammationKeys.all, "programmations"] as const),
  programmation: (id: string | undefined) => [...boxProgrammationKeys.all, "programmation", id] as const,
  defaultSettings: (id: string | undefined) => [...boxProgrammationKeys.all, "defaultSettings", id] as const,
}
